import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: RouteConfig[] = [
  {
    path: "/projects/create",
    name: "project_create_wizard",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.project.create.wizard" */ "../views/ProjectCreateWizard.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/projects",
    name: "projects",
    component: safeImport(
      () =>
        import(/* webpackChunkName: "route.projects" */ "../views/Projects.vue")
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/news",
    name: "news",
    component: safeImport(
      () => import(/* webpackChunkName: "route.news" */ "../views/News.vue")
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/projects/:id/request-access",
    name: "project_request_access",
    component: safeImport(() => import("../views/ProjectRequestAccess.vue")),
    meta: {
      auth: true,
    },
  },
  {
    path: "/projects/:id",
    name: "project",
    component: safeImport(
      () =>
        import(/* webpackChunkName: "route.project" */ "../views/Project.vue")
    ),
    meta: {
      auth: true,
    },
    children: [
      {
        path: "overview",
        name: "project_overview",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.overview" */ "../views/ProjectOverview.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["overview"],
          breadcrumbs: "Overview",
        },
      },
      {
        path: "data",
        name: "project_data",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.data" */ "../views/ProjectData.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["data"],
          breadcrumbs: "Data",
        },
      },
      {
        path: "protocols",
        name: "project_protocols",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.protocols" */ "../views/ProjectProtocols.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["protocols"],
          breadcrumbs: "Methods",
        },
      },
      {
        path: "notes",
        name: "project_notes",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.notes" */ "../views/ProjectNotes.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["notes"],
          breadcrumbs: "Notes",
        },
      },
      {
        path: "import-protocols",
        name: "project_import_protocols",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.protocols.import" */ "../views/ProjectImportProtocol.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["protocols"],
          breadcrumbs: "Import Methods",
        },
      },
      {
        path: "audit_trail",
        name: "project_audit_trail",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.report" */ "../views/ProjectReport.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["audit_trail"],
          breadcrumbs: "Audit Trail",
        },
      },
      {
        path: "settings",
        name: "project_settings",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.settings" */ "../views/ProjectSettings.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["settings"],
          breadcrumbs: "Settings",
        },
      },
      {
        path: "sharing",
        name: "project_sharing",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.sharing" */ "../views/ProjectSharing.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["sharing"],
          breadcrumbs: "Sharing",
        },
      },
      {
        path: "tasks",
        name: "project_tasks",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.tasks" */ "../views/ProjectTasks.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["tasks"],
          breadcrumbs: "Tasks",
        },
      },
      {
        path: "kpi",
        name: "project_kpi",
        component: safeImport(
          () =>
            import(
              /* webpackChunkName: "route.project.funding" */ "../views/ProjectKPI.vue"
            )
        ),
        meta: {
          auth: true,
          tags: ["kpi"],
          breadcrumbs: "KPI",
        },
      },
    ],
  },
];

export default routes;
